module.exports = __webpack_public_path__ + "img/kpgs-logo.8c1476f9.svg";